module.exports = __webpack_public_path__ + "media/images/vector-95@2x-b39cd86654a71368afdacae0f49f2e41.png";